module.exports = __webpack_public_path__ + "Roboto-LightItalic.056caeabe95749fe2b97.ttf";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-LightItalic.ttf
// module chunks = 16